"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeferredAction = exports.Priority = void 0;
var Priority;
(function (Priority) {
    Priority[Priority["COST"] = 0] = "COST";
    Priority[Priority["OPPONENT_TRIGGER"] = 1] = "OPPONENT_TRIGGER";
    Priority[Priority["DISCARD_BEFORE_DRAW"] = 2] = "DISCARD_BEFORE_DRAW";
    Priority[Priority["DRAW_CARDS"] = 3] = "DRAW_CARDS";
    Priority[Priority["BUILD_COLONY"] = 4] = "BUILD_COLONY";
    Priority[Priority["INCREASE_COLONY_TRACK"] = 5] = "INCREASE_COLONY_TRACK";
    Priority[Priority["PLACE_OCEAN_TILE"] = 6] = "PLACE_OCEAN_TILE";
    Priority[Priority["DEFAULT"] = 7] = "DEFAULT";
    Priority[Priority["ATTACK_OPPONENT"] = 8] = "ATTACK_OPPONENT";
    Priority[Priority["LOSE_AS_MUCH_AS_POSSIBLE"] = 9] = "LOSE_AS_MUCH_AS_POSSIBLE";
    Priority[Priority["GAIN_RESOURCE_OR_PRODUCTION"] = 10] = "GAIN_RESOURCE_OR_PRODUCTION";
    Priority[Priority["LOSE_RESOURCE_OR_PRODUCTION"] = 11] = "LOSE_RESOURCE_OR_PRODUCTION";
    Priority[Priority["DECREASE_COLONY_TRACK_AFTER_TRADE"] = 12] = "DECREASE_COLONY_TRACK_AFTER_TRADE";
    Priority[Priority["DISCARD_CARDS"] = 13] = "DISCARD_CARDS";
})(Priority = exports.Priority || (exports.Priority = {}));
var DeferredAction = (function () {
    function DeferredAction(player, execute) {
        this.player = player;
        this.execute = execute;
        this.priority = Priority.DEFAULT;
    }
    return DeferredAction;
}());
exports.DeferredAction = DeferredAction;
